import { render } from "./newslist.vue?vue&type=template&id=c1125cd6"
import script from "./newslist.vue?vue&type=script&lang=js"
export * from "./newslist.vue?vue&type=script&lang=js"

import "./newslist.vue?vue&type=style&index=0&id=c1125cd6&lang=scss"

import exportComponent from "/data/project/activity-v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__